import React from "react";
import CountryFlag from "../CountryFlag/CountryFlag";
import "./ImageDestinationBadge.scss";

/**
 * Glass-style destination pill on the physical top-left of a card image.
 * Renders nothing when label is empty.
 *
 * @param {string} [label] — resolved destination/city text
 * @param {string} [destinationCode] — LDS code for country flag
 * @param {string} [countryCode] — ISO country override
 * @param {string} [className] — optional BEM / layout modifier
 */
function ImageDestinationBadge({
  label,
  destinationCode,
  countryCode,
  className = "",
}) {
  const text = typeof label === "string" ? label.trim() : "";
  if (!text) return null;

  return (
    <span
      className={["hr-image-destination-badge", className].filter(Boolean).join(" ")}
      title={text}
      dir="auto"
    >
      <CountryFlag
        destinationCode={destinationCode}
        countryCode={countryCode}
        className="hr-country-flag--badge"
        title={text}
      />
      <span className="hr-image-destination-badge__text">{text}</span>
    </span>
  );
}

export default ImageDestinationBadge;
